// extracted by mini-css-extract-plugin
export var actionButton = "_pv-0";
export var actionMenuContainer = "_pv-i";
export var bubble = "_pv-2";
export var bubbleActionMenu = "_pv-j";
export var bubbleContext = "_pv-6";
export var bubbleItems = "_pv-7";
export var customer = "_pv-3";
export var divider = "_pv-8";
export var fileList = "_pv-9";
export var hiddenComment = "_pv-o";
export var infoAbove = "_pv-a";
export var internal = "_pv-4";
export var lightActionButton = "_pv-1";
export var link = "_pv-b";
export var merchant = "_pv-5";
export var message = "_pv-c";
export var profilePicture = "_pv-e";
export var quillToolbarContainer = "_pv-f";
export var senderDate = "_pv-g";
export var senderDateCustomer = "_pv-h";
export var senderName = "_pv-d";
export var time = "_pv-k";
export var uploadedImage = "_pv-l";
export var username = "_pv-m";
export var xsmall = "_pv-n";